<template>
  <v-chip
    depressed
    :dark="isSelected"
    :color="isSelected ? theme.color : ''"
    @click="$emit('onClick')"
    @focus="$emit('focusOption')"
    @blur="$emit('blurOption')"
  >
    <slot></slot>
  </v-chip>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: ['value', 'option', 'isSelected'],
  computed: {
    ...mapGetters({
      theme: 'getTheme'
    })
  }
}
</script>

<style lang="scss" scoped></style>
